import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTeaCoffee = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M1.48,8.18H15.8a0,0,0,0,1,0,0v7.24A7.08,7.08,0,0,1,8.72,22.5H8.56a7.08,7.08,0,0,1-7.08-7.08V8.18a0,0,0,0,1,0,0Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "plan2plate-icon",
			cx: 19.14,
			cy: 12.88,
			rx: 3.34,
			ry: 3.42
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: .52,
			y1: 22.5,
			x2: 16.75,
			y2: 22.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M3.39,1.5c1.65,1.91-.7,2.86.95,4.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M8.16,1.5c1.65,1.91-.7,2.86.95,4.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M12.93,1.5c1.66,1.91-.7,2.86,1,4.77"
		})
	]
});
const ForwardRef = forwardRef(SvgTeaCoffee);
export default ForwardRef;
